import React from 'react';
import PropTypes from 'prop-types';

import Badge from 'components/Badge';
import Message from 'components/Message';

import { UNPUBLISH_REASON } from '../Modifiers.contract';
import messages from './ModifiersTabPanel.messages';

const unpublishReasonLabel = reason =>
  reason === UNPUBLISH_REASON.INSUFFICIENT_OPTIONS ? 'insufficient options' : 'manual';

const GroupStatusBadge = ({ group }) =>
  group.published ? (
    <Badge info solid>
      <Message as="text" message={messages.publishedBadge} />
    </Badge>
  ) : (
    <Badge warn>
      <Message
        as="text"
        message={messages.unpublishedBadge}
        values={{ reason: unpublishReasonLabel(group.unpublishReason) }}
      />
    </Badge>
  );

GroupStatusBadge.propTypes = {
  group: PropTypes.shape({
    published: PropTypes.bool,
    unpublishReason: PropTypes.string,
  }).isRequired,
};

export default GroupStatusBadge;
